import React, { createContext, useContext, useState, useEffect } from 'react';
import { auth } from '../services/api';

interface AuthContextType {
    isAuthenticated: boolean;
    user: any;
    login: (username: string, password: string) => Promise<void>;
    register: (userData: any) => Promise<void>;
    logout: () => void;
}

const AuthContext = createContext<AuthContextType>({} as AuthContextType);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
    const [user, setUser] = useState<any>(null);

    useEffect(() => {
        const loadUser = async () => {
            try {
                if (isAuthenticated) {
                    const response = await auth.getProfile();
                    setUser(response.data);
                }
            } catch (error) {
                console.error('Failed to load user:', error);
                logout();
            }
        };

        loadUser();
    }, [isAuthenticated]);

    const login = async (username: string, password: string) => {
        const response = await auth.login({ username, password });
        localStorage.setItem('token', response.data.token);
        setIsAuthenticated(true);
    };

    const register = async (userData: any) => {
        const response = await auth.register(userData);
        localStorage.setItem('token', response.data.token);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, user, login, register, logout }}>
            {children}
        </AuthContext.Provider>
    );
};
